export const SUPPORT_EMAILS = Object.freeze({
  badOffer: 'badoffer@hiddenunderground.com',
  info: 'info@hiddenunderground.com',
  help: 'HelpPlease@hiddenunderground.com',
  privacy: 'HUGprivacy@hiddenunderground.com',
})

export const mailto = email => `mailto:${email}`
